import { render, staticRenderFns } from "./SalesOfSalesContributionByRegionBarChart.vue?vue&type=template&id=fc8e8610"
import script from "./SalesOfSalesContributionByRegionBarChart.vue?vue&type=script&lang=ts"
export * from "./SalesOfSalesContributionByRegionBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports